"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = AnnotationBracket;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SubjectBracket = require("../Subject/SubjectBracket");

var _SubjectBracket2 = _interopRequireDefault(_SubjectBracket);

var _BracketNote = require("../Note/BracketNote");

var _BracketNote2 = _interopRequireDefault(_BracketNote);

var _classnames = require("../classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _Type = require("./Type");

var _Type2 = _interopRequireDefault(_Type);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AnnotationBracket(props) {
  var className = (0, _classnames2.default)("bracket", props.className);
  return (0, _Type2.default)(_extends({ disable: ["connector"] }, props, { className: className }), null, null, _SubjectBracket2.default, { depth: 20 }, _BracketNote2.default);
}